import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'espacios/';

export interface Espacio {
    id: number;
    nombre: string;
    descripcion?: string;
    cantidad_personas: number;
    imagen?: string;
    estado: boolean;
    fecha_creacion: string;
    sucursal: number;        // ID de la sucursal
    sucursal_nombre?: string; 
}

export const fetchEspacios = async (): Promise<Espacio[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const createEspacio = async (data: {
    nombre: string;
    descripcion?: string;
    cantidad_personas: number;
    imagen?: File | null;
    estado: boolean;
    sucursal: number; // Campo obligatorio
}) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        formData.append('nombre', data.nombre);
        formData.append('sucursal', data.sucursal.toString());
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        formData.append('cantidad_personas', data.cantidad_personas.toString());
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());

        const response = await axiosInstance.post(API_URL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const updateEspacio = async (
    id: number,
    data: {
        nombre: string;
        descripcion?: string;
        cantidad_personas: number;
        imagen?: File | null;
        estado: boolean;
        sucursal: number;
    }
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        formData.append('nombre', data.nombre);
        formData.append('sucursal', data.sucursal.toString());
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        formData.append('cantidad_personas', data.cantidad_personas.toString());
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());

        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const deleteEspacio = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};